import React, { useState, useRef } from 'react';
import { Popover } from '@mui/material';
import ButtonStyles from '../Button/Button.module.scss';
import styles from './ButtonChipMultiple.module.scss';

interface ButtonI {
  handleClick?: (option: string) => any;
  buttonStyle?: string;
  options: string[];
  active: string;
  id?: string;
  translateFunction: (key: string) => string;
}

const ButtonChipMultiple: React.FC<ButtonI> = ({ handleClick = () => { }, buttonStyle = 'GreyFilter', options = [],
  active = '', id = '', translateFunction }) => {
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [optionSelected, setOptionSelected] = useState<string>(options[0]);
  const [open, setOpen] = useState(false);
  const changeOption = (option: string) => {
    setOptionSelected(option);
    handleClick(option);
    setOpen(false);
  };
  const onClickArrow = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen(!open);
  };
  const optionsWithoutSelected = options.filter((option) => option !== optionSelected);
  const buttonClasses = (option: string) => (
    `${ButtonStyles[buttonStyle] || ButtonStyles.Primary} ${option === active ? ButtonStyles.Active : ''}`
  );

  return (
    <>
      <button
        key={id}
        id={id}
        data-testid={id}
        type="button"
        className={buttonClasses(optionSelected)}
        onClick={() => handleClick(optionSelected)}
        ref={anchorRef}
      >
        {translateFunction(optionSelected)}
        <i
          data-testid={`${id}-arrow`}
          className={`di icon-pfeil-chevron-${open ? 'oben' : 'unten'} ${styles.Icon}`}
          onClick={onClickArrow}
        />
      </button>
      <Popover
        open={open}
        anchorEl={anchorRef.current}
        disablePortal
        sx={{ zIndex: 1 }}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        elevation={0}
      >
        <div className={styles.Options}>
          {optionsWithoutSelected.map((option) => (
            <button
              id={`${id}-${option}`}
              data-testid={`${id}-${option}`}
              key={option}
              type="button"
              className={buttonClasses(option)}
              onClick={() => changeOption(option)}
            >
              {translateFunction(option)}
            </button>
          ))}
        </div>
      </Popover>
    </>
  );
};

export default ButtonChipMultiple;
